import LocationPicker from './LocationPicker';

export default LocationPicker;
